import Wallets from "./Wallets";

export default Wallets;